import styled from 'styled-components';

const FeedbackTextArea = styled.textarea`
  border-radius: 6px;
  border: solid 2px #ededed;
  height: 150px;
  font-size: 14px;
  background-color: ${({ disabled }) => (disabled ? '#f4f5f7' : 'unset')};
  min-height: 200px;
  resize: none;
  font-family: 'OpenSans', sans-serif;
  font-weight: normal;
  color: var(--river-bed);
  padding: 6px 12px;
  width: 100%;
`;

export default FeedbackTextArea;
